{
  "name": "@xiboplayer/core",
  "version": "0.7.23",
  "description": "xiboplayer core orchestration and lifecycle management",
  "type": "module",
  "main": "./src/index.js",
  "types": "./src/index.d.ts",
  "exports": {
    ".": "./src/index.js",
    "./player-core": "./src/player-core.js"
  },
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:ui": "vitest --ui",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "@xiboplayer/utils": "workspace:*"
  },
  "peerDependencies": {
    "@xiboplayer/cache": "workspace:*",
    "@xiboplayer/renderer": "workspace:*",
    "@xiboplayer/schedule": "workspace:*",
    "@xiboplayer/xmds": "workspace:*"
  },
  "devDependencies": {
    "@vitest/coverage-v8": "^4.1.3",
    "@vitest/ui": "^4.1.4",
    "jsdom": "^29.0.2",
    "vite": "^8.0.8",
    "vitest": "^4.1.2"
  },
  "keywords": [
    "xibo",
    "digital-signage",
    "player",
    "core",
    "orchestration"
  ],
  "author": "Pau Aliagas <linuxnow@gmail.com>",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xibo-players/xiboplayer.git",
    "directory": "packages/core"
  },
  "homepage": "https://xiboplayer.org"
}
